var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"prescreenBanner",attrs:{"id":"banner"}},[_c('div',{staticClass:"inner atlas-banner"},[_c('h3',[_vm._v("We've matched you to your pre-approved offer up to $"+_vm._s(_vm.maxLoanAmount)+"!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }